import { DraggableTree } from "vue-draggable-nested-tree";
import Helper from '../Helper'
import lodash from 'lodash'
import { mapGetters } from 'vuex'

export default {
  name: "add-checklist-item",
  components: {
    Tree: DraggableTree
  },
  props: [],
  data() {
    return {
      tag: [this.$route.params.tag],
      tagDf: this.$route.params.tag,
      chooice: [],
      select_group: {},
      preview: [],
      chk_items: []
    };
  },
  computed: {
    ...mapGetters({
      tags: 'Tag/getListTag',
    }),
    data() {
      return this.$store.getters[
        "GroupChecklistItem/getListGroupChecklistItem"
      ];
    }
  },
  mounted() {
    this.$loading.start();
    if (this.data.length == 0) {
      Promise.all([
        this.$store.dispatch("GroupChecklistItem/getListGroupChecklistItem", {
          page: 1,
          per_page: "all"
        }),
        this.$store.dispatch("Status/getListStatus")
      ])
        .then(res => {
          this.$loading.complete();
        })
        .catch(errors => {
          this.$loading.fail();
        });
    }else{
      this.$loading.complete();
    }
  },
  methods: {

    select (selected) {
      console.log(selected)
      this.select_group = {}
      this.$loading.start()
      console.log(this.data)
      this.$store.dispatch('GroupChecklistItem/showGroupChecklistItem', {group_checklist_item: selected, status: this.$status.APPROVAL}).then(res => {
        var parent = []
        var chooice = []
        console.log(this.data)
        this.data.forEach(element => {
          parent = parent.concat(Helper.getUnNestedChildren(element))
        })
        console.log(this.data)
        this.chooice.forEach(element => {
          chooice = chooice.concat(Helper.getUnNestedChildren(element))
        })
        var tam = lodash.orderBy(Helper.getDiff(Helper.getParent(res.id, parent).concat(Helper.getUnNestedChildren(res)), chooice), 'id')
        this.chooice = Helper.getNestedChildren(tam, 0)
        this.$loading.complete()
      }).catch(errors => {
        console.log(errors)
        this.$loading.fail()
      })
    },

    removeGroup (data) {
      this.select_group = {}
      var chooice = []
      this.chooice.forEach(element => {
        chooice = chooice.concat(Helper.getUnNestedChildren(element))
      })
      var index = lodash.findIndex(chooice, ['id', data.id])
      chooice.splice(index, 1)
      this.chooice = Helper.getNestedChildren(chooice, 0)
    },

    selectChecklistItem (data) {
      this.select_group = data
    },

    destroyItem (item) {
      var index = lodash.findIndex(this.select_group.chk_items, ['id', item.id])
      var tamp = this.select_group.chk_items[index]
      item.destroy = true
      this.select_group.chk_items.splice(index, 1, tamp)
    },

    addTag () {
      this.$refs.modalAddTag.show()
    },

    checklistItem (preview) {
      preview?this.$refs.preview.show():'';
      var groups = []
      var items = []
      this.preview = []
      this.chk_items = []
      this.chooice.forEach(element => {
        groups = groups.concat(Helper.getUnNestedChildren(element))
      })
      groups.forEach(element => {
        if (element.chk_items) {
          element.chk_items.length != 0?this.preview.push(element):'';
          Object.values(element.chk_items).forEach(item => {
            if (!item.destroy) {
              this.chk_items.push(item.id)
            }
          })
        }
      })
      // console.log(groups, this.chk_items, this.preview)
    },

    save () {
      this.checklistItem(false);
      console.log(this.chk_items, this.tag)
      this.$store.dispatch('Tag/syncCheckItems',{chk_items: this.chk_items, tag: this.tag}).then(res => {
        this.$loading.complete()
        console.log(res)
      }).catch(errors => {
        if (errors.status === 422) {
          this.errors = errors.data.error
        }
        this.$loading.fail()
      })
    }
  }
};



// WEBPACK FOOTER //
// ./src/views/tag/add-checklist-item/add-checklist-item.js